<ion-list lines="full" class="group-clients">
  <ion-item-divider>
    <ion-label>{{ 'GROUP_SESSION_EDITOR.CLIENTS_TITLE' | transloco }}</ion-label>
  </ion-item-divider>

  @for (member of members; track member.id) {
    <ion-item data-cy="groupMemberItem">
      @if (careLogAssignments.length) {
        <button
          pButton
          type="button"
          slot="start"
          [icon]="isCareLogExpanded(member) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          class="p-button-text p-button-sm"
          [disabled]="busy"
          (click)="toggleCareLog(member)"
          data-cy="toggleGroupMemberCareLog"
        ></button>
      }
      <ion-label>
        {{ member.clientName || ('GROUP_SESSION_EDITOR.NO_CLIENT' | transloco) }}
        @if (isPrimary(member)) {
          <ion-text color="medium"> {{ 'GROUP_SESSION_EDITOR.PRIMARY' | transloco }}</ion-text>
        }
      </ion-label>
      <button
        pButton
        type="button"
        slot="end"
        icon="pi pi-trash"
        class="p-button-danger p-button-text p-button-sm"
        [disabled]="busy"
        (click)="onRemoveMember(member)"
        data-cy="removeGroupMember"
      ></button>
    </ion-item>
    @if (careLogAssignments.length && isCareLogExpanded(member)) {
      <ion-item lines="none" class="care-log-row" data-cy="groupMemberCareLog">
        <app-assistance-care-log-editor
          [assignments]="careLogAssignments"
          [assistanceId]="member.id"
          [clientId]="member.clientId"
          [readonly]="(editable$ | async) !== true"
          [maxTotalMinutes]="member.durationMinutes"
        />
      </ion-item>
    }
  }

  <div class="add-client-row">
    <button
      pButton
      type="button"
      icon="pi pi-plus"
      [label]="'GROUP_SESSION_EDITOR.ADD_CLIENT' | transloco"
      class="p-button-sm"
      [disabled]="busy"
      (click)="clientSelect.open()"
      data-cy="addGroupClient"
    ></button>
    <app-client-select
      #clientSelect
      class="hidden-select"
      [excludedClientIds]="memberClientIds"
      (clientSelected)="onClientPicked($event)"
    ></app-client-select>
  </div>
</ion-list>
